import { useEffect, useState } from "react";
import "../../App.css";
import classes from "./CodeUsage.module.css";
import Api from "../api/api";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import userIcon from "../../assets/user.png";
import { Button } from "reactstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const CodeUsage = () => {
  const [usageList, setUsagelist] = useState([]);
  const location = useLocation();
  const history = useHistory()

  useEffect(() => {
    Api.getCodeUsage({
      params: {
        code: location.state?.code,
      },
      onSuccess: (data) => setUsagelist(data.data),
    });
  }, []);

  return (
    <div className="main">
      <div className={classes.headerOuterContainer}>
        <div className={classes.header}>
          <div className={classes.headerLeft} />
          <div className={classes.headerTextContainer}>
            <h2 className={classes.headerText}>
              Users registered with "{location.state?.code}" code
            </h2>
          </div>
        </div>
        <Button onClick={() => history.goBack()}>Go back</Button>
      </div>
      {usageList.map((item, index) => (
        <CodeUsageItem item={item} key={index} />
      ))}
      <span style={{ textAlign: "center" }}>
        Total of {usageList.length} users
      </span>
    </div>
  );
};

const CodeUsageItem = ({ item }) => {
  return (
    <div className={classes.itemContainer}>
      <div className={classes.leftContainer}>
        <img src={userIcon} width={40} height={40} />

        <div className={classes.userInfoContainer}>
          <span>
            {item.user.fname} {item.user.lname}
          </span>
          <span>{item.user.email}</span>
        </div>
      </div>
      <div className={classes.rightContainer}>
        <span>
          {new Intl.DateTimeFormat("en-US", {
            timeZone: "US/Central",
            timeStyle: "short",
            dateStyle: "long",
          }).format(new Date(item.added_date + "Z"))}
        </span>
      </div>
    </div>
  );
};

export default CodeUsage;
